export default __webpack_public_path__ + "static/media/SZ04a.7480a9ac.mp3";